/**
 * Accurately measures the dimensions of an element, even if it's hidden.
 * Creates and measures a temporary clone to get precise dimensions without affecting the UI.
 *
 * @param element - The DOM element to measure
 * @param options - Additional configuration options
 * @returns The element's DOMRect with accurate dimensions
 */
export function measureElementSize(
  element: HTMLElement,
  options: {
    removeClasses?: string[];
    addClasses?: string[];
  } = {},
): DOMRect {
  const clone = element.cloneNode(true) as HTMLElement;

  Object.assign(clone.style, {
    visibility: "hidden",
    opacity: "0",
    position: "absolute",
    display: "block",
    width: "auto",
    height: "auto",
    maxWidth: "none",
    transform: "none",
    transition: "none",
    pointerEvents: "none",
    zIndex: "-1",
  });

  if (options.removeClasses) {
    options.removeClasses.forEach((className) => {
      clone.classList.remove(className);
    });
  }

  if (options.addClasses) {
    options.addClasses.forEach((className) => {
      clone.classList.add(className);
    });
  }

  document.body.appendChild(clone);
  const rect = clone.getBoundingClientRect();
  document.body.removeChild(clone);

  return rect;
}
